export class Step5 {
	public intitule = 'stepper.form.simp_in.step5';

	public getoui = 'form.simp_in.getoui';
	public getnon = 'form.simp_in.getnon';
	public getspan26 = 'form.simp_in.getspan26';

	public visiteDetail = 'form.simp_in.getvisitedetail';
	public autresInformComplementaire = 'form.simp_in.getautresinformcomplementaire';

	constructor() {}
}
